import React from 'react'
import { Button, Box } from '@mui/material';

const ActionButton = (props) => {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'end', gap: 1 }} >
        <Button
            style={{ marginTop: '20px' }}
            variant="contained"
            onClick={props?.onOkClick}
            size="small"
        >
            OK
        </Button>
        <Button
            style={{ marginTop: '20px' }}
            variant="outlined"
            onClick={props?.closePopup}
            size="small"
        >
            Cancel
        </Button>
    </Box>
  )
}

export default ActionButton